<template>
    <div class="exchange_dialog">
        <div class="dialog">
            <div class="close" @click="close"></div>
            <div class="title">输入兑换码</div>
            <div class="sub-title">请输入您的兑换码以解锁课程内容</div>
            <input class="ipt-code" v-model="form.code" placeholder="请输入兑换码" @change="changeCode" @input="changeCode" />
            <div class="error" v-if="error.visible">{{ error.msg }}</div>
            <div class="foot-bottons">
                <div class="abtn btn-cancel" @click="close">取消</div>
                <div class="abtn btn-enter" @click="onEnter">确认兑换</div>
            </div>
        </div>
    </div>
    <SliderVerifyVue @verified="onVerified" v-if="verifyVisible" />
</template>

<script>
import { showSuccessToast, showFailToast, showToast } from 'vant'
import { get, post } from '../utils/request'
import SliderVerifyVue from './SliderVerify.vue'
export default {
    components: { SliderVerifyVue },
    props: ['courseId'],
    data() {
        return {
            error: {
                visible: false,
                msg: ''
            },
            form: {
                id: '',
                code: '',
                verify: ''
            },
            verifyVisible: false,
            nextVerifyVisible: false
        }
    },
    created() {
        this.form.id = this.courseId
    },
    mounted() {},
    methods: {
        close() {
            this.$emit('close')
        },
        async onEnter() {
            if (!this.form.code) {
                this.error.visible = true
                this.error.msg = '* 请输入您的兑换码以解锁课程内容'
                return false
            }
            if (this.nextVerifyVisible) {
                this.nextVerifyVisible = false
                this.verifyVisible = true
            } else {
                this.onEnterNext()
            }
        },
        async onEnterNext() {
            if (this.submiting) return
            this.submiting = true
            var res = await post('/user/exchange', this.form)
            this.submiting = false
            if (res.code == 0) {
                if (!res.data) {
                    showSuccessToast('兑换成功')
                }
                this.$emit('success', res.data)
                this.close()
            } else {
                this.error.visible = true
                this.error.msg = '* ' + res.msg
                if (res.code == 2) {
                    // 下次需要验证码
                    this.nextVerifyVisible = true
                }
                return false
            }
        },
        onVerified(e) {
            console.log(e)
            this.form.verify = e.left
            this.verifyVisible = false
            this.onEnterNext()
        },
        changeCode() {
            this.error.visible = false
            this.error.msg = ''
        }
    }
}
</script>
<style scoped lang="scss">
$s1024: 1;
$s750: 1.4;
.exchange_dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.8);
    .dialog {
        width: 3.74rem;
        height: 2.45rem;
        background: url(../assets/exchange_dialog.png) no-repeat center center;
        background-size: contain;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        padding: 0.22rem 0.3rem;
        @media screen and (max-width: 1024px) {
            width: (3.74rem * $s1024);
            height: (2.45rem * $s1024);
        }
        @media screen and (max-width: 750px) {
            width: (3.74rem * $s750);
            height: (2.45rem * $s750);
        }
        .close {
            width: 0.66rem;
            height: 0.66rem;
            position: absolute;
            right: 0;
            top: 0;
            cursor: pointer;
            @media screen and (max-width: 1024px) {
                width: (0.66rem * $s1024);
                height: (0.66rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (0.66rem * $s750);
                height: (0.66rem * $s750);
            }
        }
        .title {
            font-size: 0.18rem;
            color: #0c1721;
            margin-bottom: 0.1rem;
            font-weight: bold;
            @media screen and (max-width: 1024px) {
                font-size: (0.18rem * $s1024);
                margin-bottom: (0.1rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                font-size: (0.18rem * $s750);
                margin-bottom: (0.1rem * $s750);
            }
        }
        .sub-title {
            font-size: 0.12rem;
            color: #6f6e71;
            @media screen and (max-width: 1024px) {
                font-size: (0.12rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                font-size: (0.12rem * $s750);
            }
        }
        .ipt-code {
            appearance: none;
            -moz-appearance: none;
            margin: 0;
            padding: 0;
            width: 2.82rem;
            height: 0.3rem;
            position: absolute;
            left: 0.58rem;
            top: 0.98rem;
            border: none;
            border-radius: 0;
            background-color: transparent;
            color: #000;
            outline: none;
            font-size: 0.12rem;
            line-height: 0.3rem;
            @media screen and (max-width: 1024px) {
                width: (2.82rem * $s1024);
                height: (0.3rem * $s1024);
                left: (0.58rem * $s1024);
                top: (0.98rem * $s1024);
                font-size: (0.12rem * $s1024);
                line-height: (0.3rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (2.82rem * $s750);
                height: (0.3rem * $s750);
                left: (0.58rem * $s750);
                top: (0.98rem * $s750);
                font-size: (0.12rem * $s750);
                line-height: (0.3rem * $s750);
            }
            &::placeholder {
                color: rgba(0, 0, 0, 0.5);
            }
        }
        .error {
            position: absolute;
            left: 0.3rem;
            top: 1.45rem;
            width: 2.82rem;
            height: 0.14rem;
            font-size: 0.1rem;
            color: #eb2234;
            @media screen and (max-width: 1024px) {
                left: (0.3rem * $s1024);
                top: (1.45rem * $s1024);
                width: (2.82rem * $s1024);
                height: (0.14rem * $s1024);
                font-size: (0.1rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                left: (0.3rem * $s750);
                top: (1.45rem * $s750);
                width: (2.82rem * $s750);
                height: (0.14rem * $s750);
                font-size: (0.1rem * $s750);
            }
        }
        .foot-bottons {
            width: 3.2rem;
            height: 0.37rem;
            position: absolute;
            left: 0.3rem;
            bottom: 0.3rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            @media screen and (max-width: 1024px) {
                width: (3.2rem * $s1024);
                height: (0.37rem * $s1024);
                left: (0.3rem * $s1024);
                bottom: (0.3rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (3.2rem * $s750);
                height: (0.37rem * $s750);
                left: (0.3rem * $s750);
                bottom: (0.3rem * $s750);
            }
            .abtn {
                width: 1.55rem;
                height: 0.37rem;
                border-radius: 0.06rem;
                font-size: 0.17rem;
                color: #6f6e71;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-content: center;
                align-items: center;
                cursor: pointer;
                @media screen and (max-width: 1024px) {
                    width: (1.55rem * $s1024);
                    height: (0.37rem * $s1024);
                    border-radius: (0.06rem * $s1024);
                    font-size: (0.17rem * $s1024);
                }
                @media screen and (max-width: 750px) {
                    width: (1.55rem * $s750);
                    height: (0.37rem * $s750);
                    border-radius: (0.06rem * $s750);
                    font-size: (0.17rem * $s750);
                }
                &.btn-cancel {
                    background-color: #d9dde3;
                }
                &.btn-enter {
                    color: #fff;
                    background-color: #eb2234;
                }
            }
        }
    }
}
</style>
